import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from '../../styles/cr.module.scss';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { SignOffType } from '../../refData/SignOffType';
import { useParams } from 'react-router-dom';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { CrCommandBar } from '../cr/CrCommandBar';
import { DraftReportList } from '../draftReport/DraftReportList';

interface PortfolioUpdatesProps extends IWithErrorHandlingProps {
    lastObjectiveIdForChilds?: number | null;
    setLastObjectiveIdForChilds?: React.Dispatch<React.SetStateAction<number | null>>;

    lastDirectorateIdForChilds?: number;
    apiConnected: boolean;
    emphasiseProjectsWithCustomField: string;
    emphasisedProjectsHeaderText: string;
    otherProjectsHeaderText: string;
}

const PortfolioUpdates = (props: PortfolioUpdatesProps) => {

    const { portfolioIdForUpdates } = useParams<{ portfolioIdForUpdates: string }>();
    const history = useHistory();

    const commandBarItems: ICommandBarItemProps[] = [
        {
            key: 'portfolios',
            text: 'Back to Portfolios',
            iconProps: { iconName: 'Back' },
            onClick: (ev, item) => {
                if (props.lastObjectiveIdForChilds != null) {
                    history.push(`/a2/portfolios-for-objective/${props.lastObjectiveIdForChilds}`);
                }
                else {
                    history.push('/a2/portfolios');
                }

            },
        },
        {
            key: 'signoff',
            text: 'Review & Sign Off',
            iconProps: { iconName: 'MiniExpand' },
            onClick: (ev, item) => {
                history.push(`/a2/sign-off-for-portfolio/${portfolioIdForUpdates}`);
            },
        }
    ];


    return (

        <div className={`${styles.updatesContainer}`}>
            <CrCommandBar items={commandBarItems} />
            <div>
                <DraftReportList
                    defaultReportType={SignOffType.Portfolio}
                    defaultEntityId={Number(portfolioIdForUpdates)}
                    {...props}
                />
            </div>


        </div>

    );
};

export default withErrorHandling(PortfolioUpdates);